import { createNamedContext } from '@trinity/chat-components';
import type { TranscribeRT } from '@/types';
import type { Transcript } from './interfaces';

export const TranscriptHighlightsContext = createNamedContext<TranscribeRT.Highlight[]>([], 'Transcript.Highlights.Context');
export const TranscriptHighlightActionsContext = createNamedContext<Transcript.HighlightsActionsContextValue>(undefined, 'Transcript.Highlights.Actions.Context');